import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="submit-form"
export default class extends Controller {
  submitOnChange() {
    this.element.requestSubmit()
  }

  formSubmitOnChange() {
    this.element.form?.requestSubmit()
  }
}
